// utils/excelUtils.js
// Download filtered resumes as zip
export const downloadFilteredResumes = async (currentFilters = {}, showSuccess, showError) => {
  try {
    const queryParams = new URLSearchParams();

    const filterKeys = [
      "departments",
      "skillsKnown",
      "branches",
      "companyLocations",
      "experiences",
      "resumeStatus",
      "courses",
      "courseTypes",
      "courseNames",
      "courseType",
      "courseName",
      "batch",
      "learningMode",
      "branch",
      "searchField",
      "searchValue"
    ];

    // Add only existing filters to URL
    filterKeys.forEach((key) => {
      if (currentFilters[key]) {
        queryParams.append(key, currentFilters[key]);
      }
    });

    const token = localStorage.getItem("token");
    const url = `${process.env.REACT_APP_API_URL}/resumes/downloadall?${queryParams.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    const currentDate = new Date().toISOString().split("T")[0];
    link.download = `Filtered_Resumes_${currentDate}.zip`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    showSuccess("Resumes downloaded successfully!");
  } catch (error) {
    console.error("Error downloading resumes:", error);
    showError("Failed to download resumes. Please try again.");
  }
};


export const formatValue = (value) => {
  if (value === null || value === undefined || value === 'null' || value === '') {
    return '';
  }
  return value;
};

// Add this function to utils/excelUtilspb.js
export const downloadFilteredExcel = async (filters, showSuccess, showError) => {
  try {
    const token = localStorage.getItem('token');

    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (!value) return;

      if (Array.isArray(value)) {
        if (value.length > 0) {
          queryParams.append(key, value.join(","));
        }
      } else {
        queryParams.append(key, value);
      }
    });

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/placed-students-excel?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to download Excel file');
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const currentDate = new Date().toISOString().split('T')[0];
    link.download = `Placed_Students_${currentDate}.xlsx`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    showSuccess('Excel downloaded successfully!');
  } catch (error) {
    console.error('Error downloading Excel:', error);
    showError(`Failed to download Excel: ${error.message}`);
  }
};
